var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49505 2.49835H3.33114C2.8712 2.49835 2.49835 2.8712 2.49835 3.33114V9.16062C2.49835 9.62055 2.8712 9.9934 3.33114 9.9934H7.49505C7.95499 9.9934 8.32784 9.62055 8.32784 9.16062V3.33114C8.32784 2.8712 7.95499 2.49835 7.49505 2.49835Z",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6557 2.49835H12.4918C12.0318 2.49835 11.659 2.8712 11.659 3.33114V5.82949C11.659 6.28942 12.0318 6.66227 12.4918 6.66227H16.6557C17.1156 6.66227 17.4885 6.28942 17.4885 5.82949V3.33114C17.4885 2.8712 17.1156 2.49835 16.6557 2.49835Z",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6557 9.9934H12.4918C12.0318 9.9934 11.659 10.3663 11.659 10.8262V16.6557C11.659 17.1156 12.0318 17.4885 12.4918 17.4885H16.6557C17.1156 17.4885 17.4885 17.1156 17.4885 16.6557V10.8262C17.4885 10.3663 17.1156 9.9934 16.6557 9.9934Z",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49505 13.3245H3.33114C2.8712 13.3245 2.49835 13.6974 2.49835 14.1573V16.6557C2.49835 17.1156 2.8712 17.4884 3.33114 17.4884H7.49505C7.95499 17.4884 8.32784 17.1156 8.32784 16.6557V14.1573C8.32784 13.6974 7.95499 13.3245 7.49505 13.3245Z",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.dc70d9c07bfce3b34d95867d732eb904.svg";
export { ForwardRef as ReactComponent };